export default __webpack_public_path__ + "static/media/03-active.66b05508.svg";